import { Colors } from './colorMap';

type PhotoKitType = {
  id: number;
  art_type: string;
  name: string;
  color: Colors;
}[];

export const PHOTO_KIT: PhotoKitType = [
  {
    id: 1,
    art_type: 'ORIGINAL',
    name: 'Original',
    color: 'pink',
  },
  {
    id: 2,
    art_type: 'VINTAGE',
    name: 'Sepia',
    color: 'blue',
  },
  {
    id: 3,
    art_type: 'POP_ART',
    name: 'Pop Art',
    color: 'green',
  },
];
